import { render, staticRenderFns } from "./BreakDownWidget.vue?vue&type=template&id=1444230e&scoped=true&"
import script from "./BreakDownWidget.vue?vue&type=script&lang=js&"
export * from "./BreakDownWidget.vue?vue&type=script&lang=js&"
import style0 from "./BreakDownWidget.vue?vue&type=style&index=0&id=1444230e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1444230e",
  null
  
)

export default component.exports